module.exports = __webpack_public_path__ + "media/img/img-video-36894c62.png";